import axios, { AxiosResponse } from 'axios';
import { getAccessToken } from './accessToken';
import { URL_LIBRANZAS, LIBRANZAS_APIKEY } from '@/constants/api-constants';

type LibranzaBuyer = {
    document: string;
    documentType: string;
    documentCompany: string;
    documentTypeCompany: string;
    email: string;
    mobile: string;
    name: string;
    surname: string;
};

type LibranzaPayment = {
    reference: string;
    total: number;
};

type CrearSesionPayload = {
    buyer: LibranzaBuyer;
    payments: LibranzaPayment[];
    returnUrl: string;
    cancelUrl: string;
    requestId?: string;
};

export const setCrearSesionPlaceToPayLibranzas = (payload: CrearSesionPayload): Promise<AxiosResponse | undefined> =>
    getAccessToken()
        .then((tokenResponse) => {
            const token = tokenResponse?.data.data.id_token;
            return axios.request({
                method: 'post',
                url: `${URL_LIBRANZAS}/pagos/crear-sesion`,
                headers: {
                    apikey: LIBRANZAS_APIKEY,
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: payload,
            });
        })
        .catch((error) => {
            console.error(error);
            return undefined;
        });
